import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    text: "You made it so simple. My new site is so much faster and easier to work with than my old site.",
    name: "Leslie Alexander",
    role: "Freelance React Developer",
    img: "https://cdn.rareblocks.xyz/collection/clarity/images/testimonial/4/avatar-male-1.png",
  },
  {
    text: "A wonderful experience! Everything was clear and straightforward.",
    name: "Michael Foster",
    role: "Product Designer",
    img: "https://cdn.rareblocks.xyz/collection/clarity/images/testimonial/4/avatar-male-2.png",
  },
  {
    text: "Excellent service and very professional. I’m so happy with the results!",
    name: "Jenny Wilson",
    role: "UI/UX Designer",
    img: "https://cdn.rareblocks.xyz/collection/clarity/images/testimonial/4/avatar-female-1.png",
  },
  // Add more testimonial objects here if needed
];

const TestimonialPage = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,  // Show 3 cards on desktop
        slidesToScroll: 1,
        autoplay: true,      // Enable auto sliding
        autoplaySpeed: 3000, // Slide every 5 seconds
        responsive: [
          {
            breakpoint: 768, // Below 768px width (mobile)
            settings: {
              slidesToShow: 1, // Show only 1 card on mobile
            }
          }
        ]
      };
      

  return (
    <section className="py-12 bg-gray-50 sm:py-16 lg:py-20" >
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex flex-col items-center">
          <div className="text-center">
            <p className="text-lg font-medium text-gray-600 font-pj">
              2,157 people have said how good Rareblocks
            </p>
            <h2 className="mt-4 text-3xl font-bold text-gray-900 sm:text-4xl xl:text-5xl font-pj">
              Our happy clients say about us
            </h2>
          </div>

          <div className="mt-8 text-center md:mt-16 md:order-3">
            <a
              href="#"
              title=""
              className="pb-2 text-base font-bold leading-7 text-gray-900 transition-all duration-200 border-b-2 border-gray-900 hover:border-gray-600 font-pj focus:outline-none focus:ring-1 focus:ring-gray-900 focus:ring-offset-2 hover:text-gray-600"
            >
              Check all 2,157 reviews
            </a>
          </div>

          <div className="relative mt-10 md:mt-24 md:order-2 max-w-7xl w-full" >
            <Slider {...settings}>
              {testimonials.map((item, index) => (
                <div key={index} className="p-4">
                  <div className="flex flex-col overflow-hidden shadow-xl rounded-lg bg-white p-6 lg:py-8 lg:px-7 h-full ">
                    <div className="flex items-center mb-4">
                      {[...Array(5)].map((_, i) => (
                        <svg
                          key={i}
                          className="w-5 h-5 text-[#FDB241]"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                    <blockquote className="text-lg leading-relaxed text-gray-900 font-pj mb-6 flex-grow">
                      “{item.text}”
                    </blockquote>

                    <div className="flex items-center mt-auto">
                      <img
                        className="flex-shrink-0 object-cover rounded-full w-11 h-11"
                        src={item.img}
                        alt={item.name}
                      />
                      <div className="ml-4">
                        <p className="text-base font-bold text-gray-900 font-pj">{item.name}</p>
                        <p className="mt-0.5 text-sm font-pj text-gray-600">{item.role}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialPage;
